import(/* webpackMode: "eager" */ "/app/src/app/(frontend)/[locale]/error.tsx");
